module.exports = __webpack_public_path__ + "img/big_1_8.8e01ea50.png";